import { HvacGroup } from '@belimo-retrofit-portal/logic';
import { pipe } from 'fp-ts/function';
import { mapWithIndex } from 'fp-ts/ReadonlyRecord';
import { HVAC_AREA_MAP } from 'src/modules/hvac/constants/area';
import { HvacConfig } from 'src/modules/hvac/types/HvacConfig';
import { HvacFormGroupData } from 'src/modules/hvac/types/HvacFormData';
import { getDefaultFormSection } from 'src/modules/hvac/utils/getDefaultFormSection';

export function getDefaultFormGroup(config: HvacConfig[HvacGroup]): HvacFormGroupData {
  return {
    title: '',
    annotations: {
      actual: {},
      future: {},
    },
    areas: pipe(
      HVAC_AREA_MAP,
      mapWithIndex((area) => ({
        visible: true,
        comment: '',
        sections: config[area].map(getDefaultFormSection),
      })),
    ),
  };
}
